// extracted by mini-css-extract-plugin
export default {"CustomFontsContainer":"CustomFonts_CustomFontsContainer__hWODo"};